import React from 'react';

import { getActiveFeatureFlags } from '../../helpers/featureFlags';
import { useClientHasRendered } from '../../helpers/hooks';

export const FeatureFlagNotification = () => {
  const clientHasRendered = useClientHasRendered();

  if (!clientHasRendered) {
    return <></>;
  }

  const activeFlags = getActiveFeatureFlags();

  return activeFlags.length > 0 ? (
    <div className="bg-success text-sea-foam pointer-events-none absolute top-0 right-auto left-0 p-1 text-center">
      active featureFlags: {activeFlags.map(flag => ` ${flag}`)}
    </div>
  ) : (
    <></>
  );
};
